import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	graphData: [
		{
			"title": "",
			"color": "",
			"value": 0,
		}
	]
};

const donutChartSlice = createSlice({
	name: "donutChart",
	initialState: initialState,
	reducers: {
		updateGraph(state, action) {
			// console.log("update donutChart");
			// console.log(action);

			state.graphData = action.payload;
		},
	},
});

export const donutChartActions = donutChartSlice.actions;

export default donutChartSlice;
